import { useCallback, useRef } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
/**
 * Хук, позволяющий создающий стабильную ссылку на прокидываемый в неё callback.
 * Даже при изменении прокидываемой в неё функцию, остаётся стабильным
 * @param callback фукнция, которую мемоизируем
 * @returns функцию, с вечной стабильной ссылкой
 */
export const useRefCallback = function useRefCallback(callback) {
    const ref = useRef(callback);
    useIsomorphicLayoutEffect(() => {
        // Перезаписываем на каждый ререндер функцию в ref
        ref.current = callback;
    });
    const memoizedCallback = useCallback((...args) => {
        // Вызываем всегда свежую функцию
        return ref.current(...args);
    }, []);
    return memoizedCallback;
};
